<dc-page-header-wave
  [title]="'Sobre HORAX3'"
  [subtitle]="
    'Política de privacidad, Terminos y condiciones, aviso legal, uso de cookies.'
  "
>
</dc-page-header-wave>
<dc-about-overview></dc-about-overview>
<!-- <dc-about-video></dc-about-video>
<dc-about-solutions></dc-about-solutions>
<dc-counter4></dc-counter4>
<dc-about-features></dc-about-features>
<dc-about-customers></dc-about-customers>
<dc-about-team></dc-about-team>

<dc-trust-us [title]="'They trust us'"></dc-trust-us>
<dc-developer-designer></dc-developer-designer>

<dc-about-register></dc-about-register> -->

<dc-footer1></dc-footer1>
